import { cn } from './cn';
import { FC } from 'react';

export const ClockIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19" fill="none" className={cn('h-full w-full', className)}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99999 17.6291C13.4896 17.6291 17.1291 13.9896 17.1291 9.49999C17.1291 5.01039 13.4896 1.37085 8.99999 1.37085C4.51039 1.37085 0.87085 5.01039 0.87085 9.49999C0.87085 13.9896 4.51039 17.6291 8.99999 17.6291ZM9.02295 15.6895C12.5097 15.6895 15.3133 12.9868 15.3133 9.50004C15.3133 6.01333 12.4868 3.18679 9.00004 3.18679C5.51333 3.18679 2.68679 6.01333 2.68679 9.50004C2.68679 12.9868 5.53624 15.6895 9.02295 15.6895Z"
        fill="#2F2925"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.09709 5.13914C9.57763 5.13777 9.94022 5.53436 9.94145 5.99906L9.7275 9.7422L11.6216 9.2138C12.2487 8.97405 12.804 8.99152 12.9887 9.33797C13.1921 9.76553 12.8533 10.1096 12.4123 10.3929C11.9713 10.6763 9.9307 11.6461 9.39432 11.7883C8.85795 11.9304 8.32596 11.5042 8.32304 10.958L8.32303 10.956L8.23743 5.99906C8.23489 5.52441 8.62171 5.13397 9.09709 5.13914Z"
        fill="#2F2925"
      />
    </svg>
  );
};
